'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * Splittet Text an **fett** und gibt React-Knoten zurück.
 * split mit Capture-Gruppe -> ungerade Indizes sind die fetten Teile.
 */
function renderBold(text) {
  return text.split(/\*\*(.*?)\*\*/g).map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
}

/**
 * Fließtext-Block: optionale Eyebrow + H2 + Absätze.
 */
export function RichTextBlock({ background, eyebrow, headline, content = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <FadeIn>
          <div className="max-w-4xl mx-auto">
            {eyebrow && (
              <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2 text-center">
                {eyebrow}
              </p>
            )}
            {headline && (
              <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-8 text-center text-gray-900 dark:text-gray-100">
                {headline}
              </h2>
            )}
            <div className="prose prose-lg max-w-none">
              {content.map((para, i) => (
                <p key={i} className="text-gray-700 dark:text-gray-300 mb-4">
                  {renderBold(para)}
                </p>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
